var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    style: { width: "100%", height: "100%" },
    attrs: { id: "trend" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }